var map = {
	"./BeHappy.jsx": 57278,
	"./BeHealthy.jsx": 98983,
	"./BeatTheHeat.jsx": 94158,
	"./CreateCommunity.jsx": 26002,
	"./EatLocal.jsx": 88418,
	"./FindShelter.jsx": 97949,
	"./HaveItAll.jsx": 61503,
	"./NatureInTheCity.jsx": 61694,
	"./PowerThisPlace.jsx": 78469,
	"./ProtectFromFlooding.jsx": 77760,
	"./ProtectTheCoast.jsx": 82169,
	"./SaveTheWorld.jsx": 56113,
	"./TravelLight.jsx": 12649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99596;